export const TOPIC_VALUES = {
  EMPTY: '',
  PRODUCT_CRITICISM: 'productCriticism',
  RECIPE_ADVICE: 'recipeAdvice',
  NUTRITIONAL_INFO: 'nutritionalInfo',
  PRODUCT_SEARCH: 'productSearch',
  PROMOTIONS: 'promotions',
  OTHER: 'other',
  BACK_CLUB: 'backClub',
  OETKER_WORLD: 'oetkerWorld',
  BAKING_MOLDS: 'bakingMolds',
} as const;

export const CASE_VALUES = {
  EMPTY: '',
  RECIPE_ADVICE: 'RecipesAndTestKitchen',
  NUTRITIONAL_REQUEST: 'NutritionalRequest',
  PRODUCTS: 'Products',
  PROMOTIONS: 'PromotionsAndCampaigns',
  OTHER: 'Other',
  BACK_CLUB: 'DrOetkerBackclub',
  OETKER_WORLD: 'DrOetkerWelt',
} as const;

export const INBOUND_VALUES = {
  GENERAL: 'General',
  COMPLAINT: 'Complaint',
};

export type TopicValue = (typeof TOPIC_VALUES)[keyof typeof TOPIC_VALUES];
export type CaseValue = (typeof CASE_VALUES)[keyof typeof CASE_VALUES];
export type InboundValue = (typeof INBOUND_VALUES)[keyof typeof INBOUND_VALUES];

type Topic = {
  value: TopicValue;
  label: string;
  case: CaseValue;
  inbound: InboundValue;
};

export const topicsConfig: { [locale: string]: Topic[] } = {
  de_DE: [
    {
      value: 'productCriticism',
      label: 'Produktkritik/Reklamation',
      case: '',
      inbound: 'General',
    },
    {
      value: 'recipeAdvice',
      label: 'Rezeptberatung',
      case: 'RecipesAndTestKitchen',
      inbound: 'General',
    },
    {
      value: 'nutritionalInfo',
      label: 'Ernährungsinformation',
      case: 'NutritionalRequest',
      inbound: 'General',
    },
    { value: 'productSearch', label: 'Produktsuche', case: 'Products', inbound: 'General' },
    {
      value: 'promotions',
      label: 'Aktionen/Gewinnspiel',
      case: 'PromotionsAndCampaigns',
      inbound: 'General',
    },
    { value: 'other', label: 'Sonstiges', case: 'Other', inbound: 'General' },
    { value: 'backClub', label: 'Back-Club', case: 'DrOetkerBackclub', inbound: 'General' },
    { value: 'oetkerWorld', label: 'Dr. Oetker Welt', case: 'DrOetkerWelt', inbound: 'General' },
    { value: 'bakingMolds', label: 'Backformen', case: '', inbound: 'General' },
  ],
  en_CA: [
    {
      value: 'productCriticism',
      label: 'Product Review/Complaint',
      case: '',
      inbound: 'General',
    },
    {
      value: 'recipeAdvice',
      label: 'Recipe advice',
      case: 'RecipesAndTestKitchen',
      inbound: 'General',
    },
    {
      value: 'nutritionalInfo',
      label: 'Nutritional information',
      case: 'NutritionalRequest',
      inbound: 'General',
    },
    { value: 'productSearch', label: 'Product search', case: 'Products', inbound: 'General' },
    {
      value: 'promotions',
      label: 'Promotions',
      case: 'PromotionsAndCampaigns',
      inbound: 'General',
    },
    { value: 'other', label: 'Other', case: 'Other', inbound: 'General' },
    { value: 'bakingMolds', label: 'Backing molds', case: '', inbound: 'General' },
  ],
  fr_CA: [
    {
      value: 'productCriticism',
      label: 'Commentaires/Plaintes produits',
      case: '',
      inbound: 'General',
    },
    {
      value: 'recipeAdvice',
      label: 'Conseils de recettes',
      case: 'RecipesAndTestKitchen',
      inbound: 'General',
    },
    {
      value: 'nutritionalInfo',
      label: 'Informations nutritionnelles',
      case: 'NutritionalRequest',
      inbound: 'General',
    },
    {
      value: 'productSearch',
      label: 'Recherche de produits',
      case: 'Products',
      inbound: 'General',
    },
    {
      value: 'promotions',
      label: 'Promotions',
      case: 'PromotionsAndCampaigns',
      inbound: 'General',
    },
    {
      value: 'other',
      label: 'Autre',
      case: 'Other',
      inbound: 'General',
    },
    {
      value: 'bakingMolds',
      label: 'Moules à pâtisserie',
      case: '',
      inbound: 'General',
    },
  ],
  en_US: [
    {
      value: 'productCriticism',
      label: 'Product Review/Complaint',
      case: '',
      inbound: 'General',
    },
    {
      value: 'recipeAdvice',
      label: 'Recipe advice',
      case: 'RecipesAndTestKitchen',
      inbound: 'General',
    },
    {
      value: 'nutritionalInfo',
      label: 'Nutritional information',
      case: 'NutritionalRequest',
      inbound: 'General',
    },
    { value: 'productSearch', label: 'Product search', case: 'Products', inbound: 'General' },
    {
      value: 'promotions',
      label: 'Promotions',
      case: 'PromotionsAndCampaigns',
      inbound: 'General',
    },
    { value: 'other', label: 'Other', case: 'Other', inbound: 'General' },
    { value: 'bakingMolds', label: 'Backing molds', case: '', inbound: 'General' },
  ],
};
